

exports.__esModule = true;
exports.$AddCardMeftRoute = undefined;

require('xo-wallet-components/src/add-card/route');

require('./directive');

var _squid = require('squid');

var $AddCardMeftRoute = exports.$AddCardMeftRoute = _squid.$ComponentRoute.extend('$AddCardMeftRoute', {

    path: 'pageAddCardMeft',
    directive: 'xo-page-add-card-meft-page',
    titleContent: 'asideHeader.addCard',
    query: ['message'],
    trackingData: {
        templateName: 'meftDeclineAddCard.dust',
        pageGoal: 'Add Card for MEFT Decline',
        buzname: {
            'fullpage': {
                'pagename': '%:de:meft-addcard',
                'pagename2': '%:de:meft-addcard:member:hermes:',
                'hier1': '%de',
                'version': 'member:%:',
                'flowname': '%de',
                'subfeature2': '%de'
            }
            // More page qualifiers come here...
        }
    },
    children: [{
        name: '$AddCardFlowRoute',
        attributes: {
            token: 'token',
            message: 'message',
            pagetitle: 'pagetitle',
            billingaddressupdated: 'billingaddressupdated',
            showmeftsection: 'showmeftsection',
            'parent-callbacks': 'callbacks'
        }
    }]
});

angular.value("$AddCardMeftRoute", $AddCardMeftRoute);
_squid.$ComponentRoute;


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-add-card-meft/route.js
 ** module id = 394
 ** module chunks = 1
 **/